<script>
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor.vue';

export default {
  components: { WootMessageEditor },
  props: {
    modelValue: {
      type: Object,
      default: () => null,
    },
  },
  emits: ['update:modelValue'],
  data() {
    return {
      labelName: '',
      pipeCode: '',
    };
  },
  watch: {
    labelName() {
      this.updateValue();
    },
    pipeCode() {
      this.updateValue();
    },
  },
  mounted() {
    this.labelName = this.modelValue?.[0]?.label_name || '';
    this.pipeCode = this.modelValue?.[0]?.pipe_code || '';
    this.updateValue();
  },
  methods: {
    isFilled(value) {
      return typeof value === 'string' && value.trim() !== '';
    },
    updateValue() {
      if (!this.isFilled(this.labelName) || !this.isFilled(this.pipeCode)) {
        this.$emit('update:modelValue', []);
        return;
      }

      this.$emit('update:modelValue', {
        label_name: this.labelName,
        pipe_code: this.pipeCode,
      });
    },
  },
};
</script>

<template>
  <div>
    <input
      v-model="pipeCode"
      type="text"
      placeholder="ID do funil"
      class="!mb-1"
    />
    <WootMessageEditor
      v-model="labelName"
      enable-variables
      :focus-on-mount="false"
      placeholder="Nome da etiqueta"
      class="editor-input"
    />
  </div>
</template>

<style lang="scss" scoped>
.editor-input {
  @apply block w-full min-w-0 max-w-full mt-1 mx-0 mb-1;

  ::v-deep .ProseMirror-menubar-wrapper {
    @apply h-[2.4375rem] px-2 py-1.5
           border border-solid border-slate-200 dark:border-slate-600
           rounded-md bg-white dark:bg-slate-900
           text-slate-800 dark:text-slate-100
           w-full min-w-0 max-w-full;
  }

  ::v-deep .ProseMirror {
    @apply min-h-0 max-h-full p-0 border-0 bg-transparent overflow-x-auto overflow-y-hidden whitespace-nowrap;

    scrollbar-width: none;
    -ms-overflow-style: none;

    &::-webkit-scrollbar {
      display: none;
    }

    p {
      @apply my-0 text-base font-normal whitespace-nowrap;
    }
  }
}

::v-deep .ProseMirror-menubar {
  @apply hidden;
}
</style>
